import { render, staticRenderFns } from "./PraticeThemeEsgManisfestSection.vue?vue&type=template&id=32052fdf"
import script from "./PraticeThemeEsgManisfestSection.vue?vue&type=script&lang=ts"
export * from "./PraticeThemeEsgManisfestSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeThemeEsgManisfestSection.vue?vue&type=style&index=0&id=32052fdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports